import { render, staticRenderFns } from "./PlayerBeeswarm.vue?vue&type=template&id=b92fce5c"
import script from "./PlayerBeeswarm.vue?vue&type=script&lang=js"
export * from "./PlayerBeeswarm.vue?vue&type=script&lang=js"
import "./PlayerBeeswarm.vue?vue&type=style&index=0&id=b92fce5c&prod&lang=css"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports